export const actionTypePrefix = '@@UserAvatarPopover';
export const reduxKey = '@@UserAvatarPopover';

//# sourceMappingURL=constants.js.map